import getBasePath from '../functions/api-resource';

const basePath = getBasePath('liquidacao', 'dashboard-cliente/configuracao');

const dashboardActions = {
  buscarCamposFiltro: { methods: 'GET', url: `${basePath}/campos/filtro` },
};

export default (resource) => resource(`${basePath}`, {}, dashboardActions);
